
<template>
  <v-container style="background-color:"  >
    
      <v-layout>
          <v-flex>
            <v-snackbar color="green" v-model="msg" >
                <v-layout wrap justify-center  >
        <v-flex text-left class="align-self-center">Submission Successful</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="msg = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
        
      </v-layout>
            </v-snackbar>
          </v-flex>
      </v-layout>
      <v-layout >
          <v-flex xs12>
           <h1>Contact Us </h1>
          </v-flex>
      </v-layout>
    <v-layout wrap justify-center class="contact">
      <v-flex md6 align-self-center>
        <v-card width="500px"  flat>
            <v-form ref="form">
          <v-layout wrap>
            <v-flex xs12> Name</v-flex>
            <v-flex><v-text-field  background-color="#a8c2ff"  :rules="[rules.required]" v-model="name"  style="border-radius:0px" solo> </v-text-field></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>E-mail</v-flex>
            <v-flex><v-text-field  background-color="#a8c2ff"  :rules="[rules.email]" v-model="email" style="border-radius:0px" solo> </v-text-field></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12> Phone</v-flex>
            <v-flex><v-text-field maxlength="10"  background-color="#a8c2ff"  :rules="phnoRules" v-model="phone" style="border-radius:0px" solo> </v-text-field></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>Subject</v-flex>
            <v-flex><v-text-field  background-color="#a8c2ff"  :rules="[rules.required]" v-model="subject" style="border-radius:0px" solo> </v-text-field></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>Description</v-flex>
            <v-flex><v-textarea background-color="#a8c2ff" style="background-color:" solo :rules="[rules.required]" v-model="description"> </v-textarea></v-flex>
          </v-layout>
          </v-form>
          <v-layout wrap justify-center>
            <v-flex ><v-btn color="green" @click="submit">Submit</v-btn></v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex md6 pt-5 class="hidden-sm-and-down">
          <v-layout wrap justify-center>
              <v-flex xs12 align-self-center py-12 style="font-family:poppins-bold;font-size:18px">
             Have any questions? we'd love to hear from you...
              </v-flex>
              <v-flex xs12 align-self-center>
        <v-img height="400px" contain src="../../assets/logos/contact4.png">
         </v-img>
              </v-flex>
          </v-layout>
        
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
    data(){
        return{
          appLoading:false,
            msg:false,
            name:"",
            email:"",
            phone:"",
            description:"",
            subject:"",
            phnoRules: [
      (v) => !!v || "Phone is required",
      (v) =>
        /[6-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/.test(v) ||
        "Phone is invalid",
    ],
            rules: {
      required: (value) => !!value || "Required.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
        }
    },
    methods:
    {
        validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
        submit()
        {
            if(this.$refs.form.validate()){

            axios({
                method:"POST",
                url:"contactus/add",
                data:{
                 name:this.name,
                 email:this.email,
                 phone:this.phone,
                 subject:this.subject,
                 notes:this.description,
                }
            })
            .then((response) =>{
                if(response.data.status)
                {
                    console.log("success");
                    this.formreset();
                    this.resetValidation();
                    this.msg =true;
                }
            })
           .catch((err) => {
          console.log(err());
          alert("error")
        });
            }
        },
        formreset()
        {
            this.name="",
            this.email="",
            this.phone="",
            this.subject="",
            this.description=""
        }

    }


}



</script>